import { useEffect, useState } from 'react';
import { Badge, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/**
 * Small fixed badge shown on every shell when the server runs in demo mode
 * (KFMS_DEMO_MODE=true, reported by /api/v1/health): the data is fictitious.
 */
export function DemoBanner() {
  const { t } = useTranslation('common');
  const [demo, setDemo] = useState(false);
  useEffect(() => {
    let alive = true;
    fetch('/api/v1/health')
      .then((r) => (r.ok ? r.json() : null))
      .then((b: { demoMode?: boolean } | null) => alive && setDemo(Boolean(b?.demoMode)))
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  if (!demo) return null;
  return (
    <Tooltip label={t('demoMode.hint')} multiline w={280} withArrow>
      <Badge
        color="orange"
        variant="filled"
        size="lg"
        radius="sm"
        style={{ position: 'fixed', bottom: 12, insetInlineStart: 12, zIndex: 400, cursor: 'help', opacity: 0.92 }}
        data-testid="demo-banner"
      >
        {t('demoMode.badge')}
      </Badge>
    </Tooltip>
  );
}
